import { useUiText } from "../../locale/UiLocale";
import type { ReactNode } from "react";
import { Icon, type IconName } from "../../icons";
import { type ModalTone, modalIconClass } from "./modalClasses";

interface ModalHeaderProps {
  title: string;
  titleId: string;
  description?: ReactNode;
  descriptionId: string;
  icon?: IconName;
  tone: ModalTone;
  headerActions?: ReactNode;
  onClose: () => void;
}

/** Icon, title and description, extra actions and the close button. */
export function ModalHeader({ title, titleId, description, descriptionId, icon, tone, headerActions, onClose }: ModalHeaderProps): React.JSX.Element {
  const t = useUiText();
  return (
    <div className="nb-modal-head">
      {icon ? (
        <span className={modalIconClass(tone)}>
          <Icon name={icon} />
        </span>
      ) : null}
      <div className="nb-modal-head-text">
        <h2 id={titleId}>{title}</h2>
        {description ? <p id={descriptionId}>{description}</p> : null}
      </div>
      {headerActions}
      <button type="button" className="nb-icon-btn nb-modal-close" aria-label={t("Close")} onClick={onClose}>
        <Icon name="x" />
      </button>
    </div>
  );
}
